import React from "react";
import SystemStatusTable from "../elements/SystemStatusTable";

import { IconClock, IconHistory, IconBrandWordpress, IconCode, IconPlug, IconPalette } from "@tabler/icons-react";

const softwareItems = [
    {
        name: "WordPress",
        icon: <IconBrandWordpress size={30} color="var(--bs-primary)" />,
        current: "5.5",
        currentTitle: "Current Version",
        recommended: "7.2",
        recommendedTitle: "Recommended Version",
        badge: "Check This!",
    },
    {
        name: "Themes",
        icon: <IconPalette size={30} color="var(--bs-danger)" />,
        current: "4",
        currentTitle: "Installed",
        recommended: "2",
        recommendedTitle: "Recommended Update",
        badge: "Check This!",
    },
];

const Themes = (props) => {
    return <>
        <SystemStatusTable systemItems={null} softwareItems={softwareItems} />
    </>
}

export default Themes;
